import {
  FETCH_DELIVERY_CONFIG,
  FETCH_DELIVERY_CONFIG_SUCCESS,
  FETCH_DELIVERY_CONFIG_FAILED,
  EDIT_DELIVERY_CONFIG
} from "../store/types";

const INITIAL_STATE = {
  parcelTypes: [],
  options: [],
  cancelSlabs: [],
  loading: false,
  error: {
    flag: false,
    msg: null
  }
};

export const deliveryConfigReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_DELIVERY_CONFIG:
      return {
        ...state,
        loading: true
      };
    case FETCH_DELIVERY_CONFIG_SUCCESS:
      return {
        ...state,
        parcelTypes: action.payload.parcelTypes || [],
        options: action.payload.options || [],
        cancelSlabs: action.payload.cancelSlabs || [],
        loading: false
      };
    case FETCH_DELIVERY_CONFIG_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_DELIVERY_CONFIG:
      return state;
    default:
      return state;
  }
};
